// removed by extract-text-webpack-plugin
module.exports = {"related-views-subpane":"related-views__related-views-subpane","command":"related-views__command"};


//////////////////
// WEBPACK FOOTER
// ./src/components/view-pane/related-views.scss
// module id = 1234
// module chunks = 0